define("tmds/symbols/Font", [
    "jquery",
    "../validator"
], function($, validator) {
	"use strict";

    /**
     * construct a new font
     * @param options {Object} font option object with below structure
     * 		{
     * 			family: "Calibri",
     * 			size: "12px",
     * 			weight: "bold",
     * 			style: "italic"
     * 		}
     * @note all option members are optional
     */
    var Font = function(options) {
    	
        /**
         * default font settings
         */
        this.family = "Arial";
        this.size = "10px";
        this.style = "normal";
        this.weight = "normal";
        
        if (options != undefined) {
        	if (validator.isDataObject(options)) {
        		if (options.family != undefined) {
        			setFamily.call(this, options.family);
        		}					
					
				if (options.size != undefined) {
					setSize.call(this, options.size);
				}
						
				if (options.style != undefined) {
					setStyle.call(this, options.style);
				}
						
				if (options.weight != undefined) {
					setWeight.call(this, options.weight);
				}					
        	}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
        }
    };
    
    /**
     * set the font family
     * @param family {String} new font family
     * @return {Font} the font itself
     * @TODO should validate if the input is a valid font family
     */
    function setFamily(family) {
    	
        if (!validator.isString(family)) {        	
        	throw new Error('Invalid font family - ' + family + ' passed.');
        }
        
        this.family = family + (family.indexOf('sans-serif') == -1 ? ', sans-serif' : '');
        
        return this;
    }

    /**
     * set the font size
     * @param size {Number} new font size
     * @return {Font} the font itself
     * @note if the input is not a number, skip it.
     */
    function setSize(size) {
        
        if (!validator.isValidFontSize(size)) {        	
        	throw new Error('Invalid font size - ' + size + ' passed.');
        }
        
        this.size = parseInt(size) + "px";
        return this;
    }

    /**
     * set the font style
     * @param style {String} new font style
     * @return {Font} the font itself
     * @note if the input is not a valid style, skip it.
     */
    function setStyle(style) {
        
        if (!validator.isValidFontStyle(style)) {        	
        	throw new Error('Invalid font style - ' + style + ' passed.');
        }
        
        this.style = style;
        return this;
    }

    /**
     * set the font weight
     * @param weight {String} new font weight
     * @return {Font} the font itself
     * @note if the input is not a valid weight, skip it.
     */
    function setWeight(weight) {
    	
    	if (!validator.isValidFontWeight(weight)) {        	
        	throw new Error('Invalid font weight - ' + weight + ' passed.');
        }
        
        this.weight = weight;
        return this;
    }

    /**
     * convert font object to JSON representation
     */
    function toJson() {
        return {
            family: this.family,
            size: this.size,
            weight: this.weight,
            style: this.style,
            type: this.type
        };
    }

    Font.prototype = {
    	declaredClass: "tmds.symbols.Font",
    	type: "Font",
    	'setFamily' : setFamily,
    	'setSize' : setSize,
    	'setStyle' : setStyle,
    	'setWeight' : setWeight,
    	'toJson' : toJson
    };

    return Font;
});